<template>
  <form class="side_box" :style="style" @submit.prevent="stopEditing">
    <h4 class="content-subtitle">General</h4>
    <div v-if="!isEditing">
      <label for="lotbon">{{ this.details.bonID == "" ? "LOT" : "BATCH" }}</label>
      <span v-if="this.details.bonID || this.details.lotID">{{
        this.details.bonID == "" ? this.details.lotID : this.details.bonID
      }}</span>
      <span v-else>/</span>
    </div>

    <div class="shared shared-2">
      <div v-if="!isEditing">
        <label for="employee">Operator</label>
        <span v-if="this.details.firstName && this.details.lastName">{{
          this.details.firstName.charAt(0) + ".  " + this.details.lastName
        }}</span>
        <span v-else>/</span>
      </div>

      <div v-if="!isEditing">
        <label for="date">{{ this.dateLabel ? this.dateLabel : "Date" }}</label>
        <span v-if="this.details.dateCreated">{{
          this.details.dateCreated | formatDate
        }}</span>
        <span v-else>/</span>
      </div>
    </div>

    <div class="shared shared-2">
      <div v-if="!isEditing">
        <label for="DHRREF">Prod. REF</label>
        <span v-if="this.details.DHRREF">{{ this.details.DHRREF }}</span>
        <span v-else>/</span>
      </div>

      <div v-if="!isEditing">
        <label for="location">Quantity</label>
        <span v-if="this.details.amount">{{ this.details.amount }}</span>
        <span v-else>/</span>
      </div>
    </div>

    <div v-if="!isEditing">
      <label for="ref">Status</label>
      <span
        v-if="this.details.created == 1 && this.details.finished == 0"
        class="status-card in-progress"
        >In Progress</span
      >
      <span
        v-if="this.details.finished == 1 && this.details.approved == 0"
        class="status-card completed"
        >Completed</span
      >
      <span v-if="this.details.approved == 1" class="status-card approved"
        >Approved</span
      >
    </div>

    <router-link
      v-if="this.details.bonID == ''"
      class="text"
      :to="'/production/dhr/' + this.details.DHRID + '/' + this.details.lotID"
      >View full DHR</router-link
    >
    <router-link
      v-if="this.details.lotID == ''"
      class="text"
      :to="'/production/dhr/' + this.details.DHRID + '/' + this.details.bonID"
      >View full DHR</router-link
    >
  </form>
</template>

<script>
import BaseIcon from "@/components/base/Icon";
import InputDash from "@/components/base/InputDash.vue";
import InputToggle from "@/components/base/InputToggle.vue";

export default {
  components: {
    BaseIcon,
    InputDash,
    InputToggle,
  },
  computed: {
    style() {
      return "height: " + this.height + "%";
    },
    userDetails() {
      return this.$store.state.userDetails;
    },
  },
  props: {
    height: String,
    details: Object,
    dateLabel: String,
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isEditing: false,
      stepID: Number,
      name: String,
      equipment: String,
      location: String,
      instruction: String,
      deviations: Boolean,
    };
  },
  watch: {
    details: {
      handler: function () {
        this.isEditing = false;
        this.setSelectedData();
      },
    },
  },
  mounted() {
    this.setSelectedData();
  },
  methods: {
    setSelectedData() {
      this.stepID = this.details.stepID;
      this.name = this.details.name;
      this.equipment = this.details.equipment;
      this.deviations = this.details.deviations;
      this.instruction = this.details.instruction;
      this.location = this.details.location;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/pages/content";
@import "@/style/components/sideBox";
@import "@/style/components/inputs";
@import "@/style/components/buttons";

.side_box {
  max-height: 690px;

  label {
    height: 20px;
  }

  input,
  span {
    height: 30px;
    margin-bottom: 15px;
  }
}

a {
  font-size: 12px;
  display: block;
  font-weight: 500;
  color: #035362;
  text-decoration: underline !important;

  position: absolute;
  top: 20px;
  right: 20px;
}

span.status-card {
  width: 104px;
  height: auto;
  padding: 8px 0;
  border-radius: 6px;
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 12px;
  text-align: center;

  &.approved {
    background-color: #e9f9ea;
    color: #2aa328;
  }
  &.completed {
    background-color: #d6e9fc;
    color: #3390f2;
  }
  &.in-progress {
    background-color: #fdecd9;
    color: #d08f40;
  }
}
</style>